/*
  Policy pages: Shopify renders the policy text, so the contents list is built here from its <h2> headings,
  "Last updated" is moved up beside the title, and the current section is highlighted while scrolling.
*/
(() => {
  const body = document.querySelector('[data-sok-policy-body] .shopify-policy__body');
  const toc = document.querySelector('[data-sok-policy-toc]');
  if (!body) return;

  // "Last updated: …" is the first paragraph in Shopify's generated policies.
  const updated = document.querySelector('[data-sok-policy-updated]');
  const first = [...body.querySelectorAll('p')].find((p) => /^last updated/i.test(p.textContent.trim()));
  if (first && updated) {
    updated.textContent = first.textContent.trim().replace(/:\s*/, ' ');
    updated.hidden = false;
    first.remove();
  }

  const headings = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
  const links = headings.map((h, i) => {
    const number = String(i + 1).padStart(2, '0');
    h.id = h.id || `section-${i + 1}-${h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`;
    h.dataset.number = number;
    const a = document.createElement('a');
    a.href = `#${h.id}`;
    a.className = 'sok-policy__toc-link';
    const num = document.createElement('span');
    num.className = 'sok-policy__toc-num';
    num.textContent = number;
    a.append(num, h.textContent.trim());
    a.addEventListener('click', (event) => {
      event.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: h.getBoundingClientRect().top + window.scrollY - 96, behavior: reduce ? 'auto' : 'smooth' });
      history.replaceState(null, '', a.hash);
    });
    toc.append(a);
    return a;
  });
  if (links.length > 1) toc.hidden = false;

  let ticking = false;
  const update = () => {
    ticking = false;
    let active = 0;
    headings.forEach((h, i) => {
      if (h.getBoundingClientRect().top < window.innerHeight * 0.3) active = i;
    });
    links.forEach((a, i) => {
      a.classList.toggle('is-active', i === active);
      if (i === active) a.setAttribute('aria-current', 'location');
      else a.removeAttribute('aria-current');
    });
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });
  update();

  document.querySelector('[data-sok-policy-print]')?.addEventListener('click', () => window.print());
})();
